/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrderInfoForSimpleFromRocketApplyGoodsForSimpleVo
 */
export interface OrderInfoForSimpleFromRocketApplyGoodsForSimpleVo {
    /**
     * 商品ID
     * @type {number}
     * @memberof OrderInfoForSimpleFromRocketApplyGoodsForSimpleVo
     */
    goodsId?: number;
    /**
     * 申请数量数量
     * @type {number}
     * @memberof OrderInfoForSimpleFromRocketApplyGoodsForSimpleVo
     */
    quantity?: number;
}

/**
 * Check if a given object implements the OrderInfoForSimpleFromRocketApplyGoodsForSimpleVo interface.
 */
export function instanceOfOrderInfoForSimpleFromRocketApplyGoodsForSimpleVo(value: object): value is OrderInfoForSimpleFromRocketApplyGoodsForSimpleVo {
    return true;
}

export function OrderInfoForSimpleFromRocketApplyGoodsForSimpleVoFromJSON(json: any): OrderInfoForSimpleFromRocketApplyGoodsForSimpleVo {
    return OrderInfoForSimpleFromRocketApplyGoodsForSimpleVoFromJSONTyped(json, false);
}

export function OrderInfoForSimpleFromRocketApplyGoodsForSimpleVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderInfoForSimpleFromRocketApplyGoodsForSimpleVo {
    if (json == null) {
        return json;
    }
    return {
        
        'goodsId': json['goodsId'] == null ? undefined : json['goodsId'],
        'quantity': json['quantity'] == null ? undefined : json['quantity'],
    };
}

export function OrderInfoForSimpleFromRocketApplyGoodsForSimpleVoToJSON(json: any): OrderInfoForSimpleFromRocketApplyGoodsForSimpleVo {
    return OrderInfoForSimpleFromRocketApplyGoodsForSimpleVoToJSONTyped(json, false);
}

export function OrderInfoForSimpleFromRocketApplyGoodsForSimpleVoToJSONTyped(value?: OrderInfoForSimpleFromRocketApplyGoodsForSimpleVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'goodsId': value['goodsId'],
        'quantity': value['quantity'],
    };
}

